<template>
    <v-container class="mb-6">

        <order-products></order-products>

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                {{ $t('Lista de Productos') }}
                <v-spacer></v-spacer>

                <!-- <v-btn
                    v-if="typeStore == 'product'"
                    class="text-capitalize mb-2 mb-sm-0 mr-2"
                    @click="dialogImportComplements = !dialogImportComplements"
                >
                    <v-icon class="mr-2" color="green">mdi-file-table</v-icon>
                    Importar Complementos
                </v-btn> -->

                <v-btn
                    class="text-capitalize mb-2 mb-sm-0 mr-2"
                    @click="dialogImport = !dialogImport"
                >
                    <v-icon class="mr-2" color="green">mdi-file-table</v-icon>
                    {{ $t('Importar') }}
                </v-btn>
                <v-btn
                    class="text-capitalize mb-2 mb-sm-0 mr-2"
                    :href="`/admin/export-products?search=${this.txtSearch}&type=${this.txtType}&category=${this.txtCategory}&status=${this.txtStatus}`"
                >
                    <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                    {{ $t('Exportar') }}
                </v-btn>

                <v-btn
                    color="primary"
                    href="/admin/new-product"
                >{{ $t('Añadir nuevo') }}</v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Producto') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='name', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='name', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>

                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSearch"
                                                    :label="$t('Buscar por nombre')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                    autofocus
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txt')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>

                        <th class="text-left" v-if="typeStore == 'product'">
                            <div class="d-flex align-center">
                                <span>{{ $t('Nombre en tienda') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='store_show_name', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='store_show_name', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>

                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtStoreShowName"
                                                    :label="$t('Buscar por nombre en tienda.')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                    autofocus
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txtStoreShowName')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>

                        <th class="text-left" v-if="typeStore == 'product'">
                            <div class="d-flex align-center">
                                <span>{{ $t('Código de barras') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='barcode', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='barcode', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>

                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtBarcode"
                                                    :label="$t('Buscar por código de barras')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                    autofocus
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('barcode')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Código Producto') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='code', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='code', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>

                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtCode"
                                                    :label="$t('Buscar por código')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                    autofocus
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('code')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Estado') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='state', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='state', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>

                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtStatus"
                                                    :items="itemsStatus"
                                                    item-text="label"
                                                    item-value="value"
                                                    :label="$t('Estado')"
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('estado')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Disponible') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='available', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='available', getListProducts()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>

                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtAvailable"
                                                    :items="[{label: $t('Disponibles'), value: '1'}, {label: $t('No disponibles'), value: '0'}]"
                                                    item-text="label"
                                                    item-value="value"
                                                    :label="$t('Disponible')"
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('available')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" v-if="(+inventory && typeStore != 'gastronomic')">
                            {{ $t('Stock interno') }}
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Tipo') }}</span>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtType"
                                                    :items="itemsTypes"
                                                    item-text="label"
                                                    item-value="value"
                                                    :label="$t('Tipo')"
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('tipo')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Categoría') }}</span>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtCategory"
                                                    :items="itemsCategories"
                                                    item-text="name"
                                                    item-value="id"
                                                    :label="$t('Categoría')"
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('categoria')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-right">
                            {{ $t('Acciones') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listProducts" :key="index">
                        <td>
                            <v-list-item class="px-0">
                                <v-list-item-avatar class="rounded-0" height="60" width="60">
                                    <v-img
                                        :src="item.banner"
                                        aspect-ratio="1.7"
                                        contain
                                    ></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.name }}
                                    </v-list-item-title>
                                    <!-- <span>texto pequeño</span> -->
                                </v-list-item-content>
                            </v-list-item>
                        </td>
                        <td v-if="typeStore=='product'">
                            {{  item.store_show_name ?? '-' }}
                        </td>

                        <td v-if="typeStore=='product'">
                            {{ (item.barcode != '' && item.barcode != 'null' && item.barcode) ? item.barcode : '-' }}
                            <v-tooltip top v-if="(item.barcode != '' && item.barcode != 'null' && item.barcode)">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        @click="generateBarcode(item.id)"
                                    >
                                        <v-icon color="grey">
                                            mdi-barcode
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('Descargar código') }}</span>
                            </v-tooltip>
                        </td>
                        <td>
                            {{ (item.code != '' && item.code != 'null') ? item.code : '-' }}
                        </td>
                        <td>
                            <v-switch
                                v-model="item.state"
                                :label="`${(item.state)? 'Activo' : 'Inactivo'}`"
                                @change="changeStateProduct(item.id)"
                                hide-details
                            ></v-switch>
                        </td>
                        <td>
                            <v-switch
                                v-model="item.available"
                                :label="`${(item.available)? 'Disponible' : 'No disponible'}`"
                                @change="changeAvailableProduct(item.id)"
                                hide-details
                            ></v-switch>
                        </td>
                        <td v-if="(+inventory && typeStore != 'gastronomic')">
                            {{ item.internal_stock??0 }}
                        </td>
                        <td>{{ (item.type=='service')?$t('Servicio'):$t('Producto') }}</td>
                        <td>
                            <ul>
                                <li v-for="(cat, m) in item.categories" :key="m">
                                    {{ cat.name }}
                                </li>
                            </ul>
                        </td>
                        <td class="text-right">
                            <div class="d-flex justify-end">
                                <v-tooltip top v-if="item.type=='service'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/edit-service/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Editar') }}</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.type=='product'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/edit-product/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Editar') }}</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="deleteProduct(item.id)"
                                        >
                                            <v-icon color="grey">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Eliminar') }}</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-row class="my-5" align="center" justify="center">
            <v-col cols="auto">
                <v-pagination
                v-model="page"
                :length="totalPage"
                :total-visible="5"
                color="primary"
                @input="changePage"
                ></v-pagination>
            </v-col>

            <v-col cols="auto">
                <v-select
                    v-model="page"
                    color="primary"
                    :items="Array.from({ length: totalPage }, (_, i) => i + 1)"
                    :label="$t('Ir a página')"
                    outlined
                    dense
                    hide-details
                    class="rounded elevation-1 text-center"
                    style="max-width: 100px; padding-top: 4px; background-color: #E3F2FD;"
                    @change="changePage"
                />
            </v-col>
        </v-row>

        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

        <!-- <v-dialog
            v-model="dialogImport"
            max-width="800"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <div class="p-2py-3 px-3">
                <v-card tile elevation="0">
                    <v-card-title>
                        Carga masiva
                    </v-card-title>

                    <v-card-text class="pa-0">
                        <v-row class="mt-5">
                            <v-col cols="6" class="py-0">
                                Cargar Por excel...
                            </v-col>
                            <v-col cols="6" class="py-0">

                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </div>
        </v-dialog> -->

        <v-dialog max-width="800"
            v-model="dialogImport"
        >
            <template v-slot:default="{ isActive }">
                <v-card>
                    <v-card-title class="py-3 blue-grey lighten-5">
                        {{ $t('Importar productos desde Excel') }}
                    </v-card-title>
                    <v-card-text>
                        <div>
                            <v-row class="my-3">
                                <v-col cols="6" class="py-0">
                                    <p>
                                        <p><b>{{ $t('Archivo base (Datos en Excel):') }}</b></p>
                                        <a href="/productos.xlsx" target='_blank' >
                                            <v-icon class="mr-2" color="green">mdi-file-table</v-icon>
                                            {{ $t('Descargar') }}
                                        </a>
                                    </p>
                                    <hr />
                                    <p>
                                        <p><b>{{ $t('Imágenes (Archivo ZIP):') }}</b></p>
                                        <p>
                                            {{ $t('Las imágenes deben estar contenidas en un archivo') }} <b>zip</b>, <br/>
                                            {{ $t('con el formato de nombre:') }} <b>[codigo_producto]_[numero].jpg</b> <br/>
                                            {{ $t('Formatos admitidos:') }} jpg, jpeg, png, gif.
                                        </p>
                                        <p>
                                            {{ $t('Ej.') }} <br/>
                                            A220_0.jpg<br/>
                                            A220_1.jpg<br/>
                                            ...etc
                                        </p>
                                    </p>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <div>
                                        <p>
                                            {{ $t('Subir archivo Excel') }}
                                        </p>
                                        <v-file-input :label="$t('Archivo')"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            v-model="importfile"
                                        ></v-file-input>
                                        <v-btn
                                            color="primary"
                                            @click="importExcel"
                                        >{{ $t('Subir') }}</v-btn>

                                    </div>
                                    <hr class="my-4">
                                    <div>
                                        <p>
                                            {{ $t('Subir Imágenes (zip):') }}
                                        </p>
                                        <v-file-input :label="$t('Archivo')"
                                            accept="application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip"
                                            v-model="importfilezip"
                                        ></v-file-input>
                                        <v-btn
                                            color="primary"
                                            @click="importImages"
                                            :disabled="zip_uploading"
                                        >
                                            {{ (zip_uploading)? "Procesando..." : "Subir Imágenes"   }}
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>

                    <!-- <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        @click="dialogImport = false"
                        >Close Dialog</v-btn>
                    </v-card-actions> -->
                </v-card>
            </template>
        </v-dialog>

        <!-- dialog barcode -->
        <v-dialog
            v-model="dialogBarCode"
            max-width="350px"
            persistent
        >
            <v-card>
                <v-card-title class="headline">
                    {{ $t('Descargar código de barras') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        :label="$t('Cantidad *')"
                        :hint="$t('Cantidad de código de barras del producto')"
                        outlined
                        dense
                        type="number"
                        min="1"
                        step="1"
                        v-model="numBarcode"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="dialogBarCode = false, numBarcode=1"
                    >
                        {{ $t('Cancelar') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        :href="`/admin/gen-barcode/${idProd}?num=${numBarcode}`"
                        target="_blank"
                    >
                        {{ $t('Descargar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- dialog import masive complements -->

        <v-dialog max-width="800"
            v-model="dialogImportComplements"
        >
            <template>
                <v-card>
                    <v-card-title class="py-3 blue-grey lighten-5">
                        {{ $t('Importar complementos de productos desde Excel') }}
                    </v-card-title>
                    <v-card-text>
                        <div>
                            <v-row class="my-3">
                                <v-col cols="6" class="py-0">
                                    <p>
                                        <p><b>{{ $t('Archivo base (Datos en Excel):') }}</b></p>
                                        <a href="/complemento_producto.xlsx" target='_blank' >
                                            <v-icon class="mr-2" color="green">mdi-file-table</v-icon>
                                            {{ $t('Descargar') }}
                                        </a>
                                    </p>
                                    <hr />
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <div>
                                        <p>
                                            {{ $t('Subir archivo Excel') }}
                                        </p>
                                        <v-file-input :label="$t('Archivo')"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            v-model="importFileCompl"
                                        ></v-file-input>
                                        <v-btn
                                            color="primary"
                                            @click="importExcelCompl"
                                        >{{ $t('Subir') }}</v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        @click="dialogImportComplements = false"
                        >{{ $t('Cerrar') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

    </v-container>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Productos/Servicios',
                    disabled: false,
                    href: '/admin/products',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            // list data
            listProducts: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            // filters
            itemsTypes: [{label: 'Producto', value: 'product'}, {label: 'Servicio', value: 'service'}],
            itemsCategories: [],
            itemsStatus: [{label: 'Activos', value: '1'}, {label: 'Inactivos', value: '0'}],
            txtSearch: '',
            txtType: '',
            txtCategory: '',
            txtStatus: '',
            txtAvailable: '',
            txtBarcode: '',
            txtCode: '',
            txtStoreShowName: '',
            orderType: 'ASC',
            orderBy: 'created_at',
            dialogImport: false,
            dialogImportComplements: false,
            importfile: null,
            importfilezip: null,
            zip_uploading: false,
            idProd: null,
            dialogBarCode: false,
            numBarcode: 1,

            importFileCompl: null,
        }
    },
    props: ['inventory', 'typeStore'],
    mounted() {
        this.getCategories();
        this.getListProducts()
    },
    methods: {
        async getCategories() {
            await axios.post('/admin/list-categories', {type: 'admin'})
            .then(response => {
                // this.itemsCategories = response.data
                response.data.forEach(category => {
                    this.itemsCategories.push({
                        id: category.id,
                        name: category.name
                    })
                    category.children.forEach(child => {
                        this.itemsCategories.push({
                            id: child.id,
                            name: ' - ' + child.name
                        })
                    })
                });
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListProducts()
        },
        changePage (event) {
            this.page = event;
            this.getListProducts()
        },
        cleanSearch (type='') {
            if (type!='') {
                if (this.txtSearch !== '' || this.txtType !== '' || this.txtCategory !== '' || this.txtStatus !== '' || this.txtBarcode !== '' || this.txtCode !== '' || this.txtStoreShowName !== '') {
                    this.listProducts = []
                    this.page = 1
                    this.txtSearch = ''
                    this.txtType = ''
                    this.txtCategory = ''
                    this.txtStatus = ''
                    this.txtBarcode = ''
                    this.txtCode = ''
                    this.txtStoreShowName = ''
                    this.getListProducts();
                }
            } else {
                switch (type) {
                    case 'txt':
                        this.txtSearch = ''
                        this.getListProducts();
                        break;
                    case 'tipo':
                        this.txtType = ''
                        this.getListProducts();
                    case 'categoria':
                        this.txtCategory = ''
                        this.getListProducts();
                        break;
                    case 'estado':
                        this.txtStatus = ''
                        this.getListProducts();
                        break;
                    case 'barcode':
                        this.txtBarcode = ''
                        this.getListProducts();
                        break;
                    case 'code':
                        this.txtCode = ''
                        this.getListProducts();
                        break;
                    case 'txtStoreShowName':
                        this.txtStoreShowName = '',
                        this.getListProducts();
                        break;
                    case 'available':
                        this.txtAvailable = '',
                        this.getListProducts();
                        break;
                    default:
                        break;
                }
            }
        },
        async getListProducts () {
            this.overlay = true
            await axios.post(`/admin/list-products?page=${this.page}&orderby=${this.orderBy}&ordertype=${this.orderType}&search=${this.txtSearch}&type=${this.txtType}&category=${this.txtCategory}&status=${this.txtStatus}&barcode=${this.txtBarcode}&code=${this.txtCode}&store_show_name=${this.txtStoreShowName}&available=${this.txtAvailable}`, {})
            .then(response => {
                // console.log(response)
                this.listProducts = response.data.data
                this.totalPage = response.data.last_page
                this.pageTable = `${this.$t('Mostrando')} <strong>${response.data.from??0} - ${response.data.to??0}</strong> ${this.$t('de un total de')} <strong>${response.data.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        },

        /**
         * Delete
         */
        deleteProduct (id) {
            this.$confirm(
                this.$t('Se eliminará permanentemente del sistema'),
                this.$t('¿Eliminar producto?'),
                'question', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: this.$t('Eliminar'),
                cancelButtonText: this.$t('Cancelar'),
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/del-prod/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', this.$t('Producto eliminado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                            this.getListProducts()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                        }
                    })
                }
            });
        },
        async changeStateProduct(prod_id) {
            let selprod = this.listProducts.find(p => p.id === prod_id);

            try {
                await axios.post('/admin/update-prod-state', {
                    product_id: selprod.id,
                    state: selprod.state
                });
            } catch (error) {}
        },
        async changeAvailableProduct(prod_id) {
            let selprod = this.listProducts.find(p => p.id === prod_id);

            try {
                await axios.post('/admin/update-prod-available', {
                    product_id: selprod.id,
                    available: selprod.available
                });
            } catch (error) {}
        },
        async importExcel(e) {
            let target = e.currentTarget;
            try {
                if(!this.importfile) { return; }

                target.innerHTML = "SUBIENDO...";
                target.disabled = true;

                let formData = new FormData();
                formData.append('file', this.importfile);
                let res = await axios.post(`/admin/upload-products-excel`, formData);

                if(res.data.success) {
                    this.$alert('', this.$t('Importación realizada con éxito.'), 'success');
                } else {
                    this.$alert(`Errores: ${res.data.errors.join(',')}`);
                }
            } catch (error) {
                console.error(error);
            } finally {
                target.innerHTML = "SUBIR";
                target.disabled = false;
            }
        },
        async importImages() {
            if(!this.importfilezip) { return; }
            let formData = new FormData();
            formData.append('file', this.importfilezip);
            try {
                this.zip_uploading = true;
                let res = await axios.post(`/admin/upload-products-imgs`, formData);
                if(res.data.success) {
                    this.$alert('', this.$t('Importación realizada con éxito.'), 'success');
                    this.importfilezip = null;
                    this.getListProducts();
                } else { this.$alert(`Errores: ${res.data.errors.join(',')}`); }
            } catch (error) {}
            finally { this.zip_uploading = false; }
        },
        async importExcelCompl(e) {
            // console.log("Importando complementos...");
            let target = e.currentTarget;
            try {
                if(!this.importFileCompl) { return; }

                target.innerHTML = "SUBIENDO...";
                target.disabled = true;

                let formData = new FormData();
                formData.append('file', this.importFileCompl);
                let res = await axios.post(`/admin/upload-products-compl`, formData);

                if(res.data.success) {
                    this.$alert('', 'Importación realizada con éxito.', 'success');
                } else {
                    this.$alert(`Errores: ${res.data.errors.join('     ')}`);
                }
            } catch (error) {
                console.error(error);
            } finally {
                target.innerHTML = "SUBIR";
                target.disabled = false;
            }
        },
        /**
         *
         * generate barcode
         *
         */
        generateBarcode(id) {
            this.idProd = id
            this.dialogBarCode = true
        }
    },
}
</script>
